// TODO: Should this do more things like hold design token root references or something?

import { FASTElementDefinition } from "@microsoft/fast-element";

export class NatGenDesignSystem {
    static prefix: string = 'natgen';
    static shadowRootMode: string = 'open';
    static registry: CustomElementRegistry = customElements;

    static register(elementDefinition: FASTElementDefinition) : void {
        elementDefinition.define(this.registry);
    }

    static registerAll(elementDefinitions: FASTElementDefinition[]) : void {
        elementDefinitions.forEach(elementDefinition => {
            elementDefinition.define(this.registry);
        });
    }
}
